import store from '@/store'

export const setMessage = (state, message) => {
  state.message = message
}

export const setApiKey = key => store.dispatch('auth/setKey', key)
